import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const View = styled.div`
    width: ${props => props.size};
    height: ${props => props.size};
    max-width: 620px;
    max-height: 620px;
    margin: auto;
    position: relative;

    &::before {
        content: '';
        width: 100%;
        height: 100%;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 55%;
        transform: translateX(-50%);
        background-color: ${props => props.color};
        opacity: 0.9;

        ${props => {
            if (props.imageSrc) {
                return css`
                    background-image: url(${props => props.imageSrc});
                    background-size: cover;
                `;
            }
        }};
    }

    &::after {
        content: '';
        width: 58%;
        height: 58%;
        border-radius: 50%;
        position: absolute;
        top: 21%;
        left: 26%;
        /* transform: translateX(-50%); */
        background-color: #fff;
    }
`;

const ImageContainer = styled.div`
    height: 100%;
    transform: rotate(15deg);
    position: relative;
    z-index: 1;
`;

const Image = styled.img`
    width: 120%;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: ${props => props.zIndex};
    transform: translate(-50%, -50%);
    pointer-events: none;
`;

const Shadow = styled.img`
    width: 100%;
    margin-left: 0;
    position: absolute;
    bottom: 4%;
    left: -10%;
    opacity: 0.75;
`;

const ProductStage = props => {
    return (
        <View color={props.color} size={props.size} imageSrc={props.imageSrc}>
            <ImageContainer size={props.size}>
                {props.productImages.map((url, i) => {
                    return (
                        <Image
                            key={url || i}
                            src={url}
                            zIndex={10 - i}
                            size={props.size}
                        />
                    );
                })}
            </ImageContainer>
            <Shadow
                src="https://cdn.blateral.com/noin/static/media/product-shadow.9f9a9412.png"
                size={props.size}
            />
        </View>
    );
};

ProductStage.defaultProps = {
    size: '100vh',
    color: '#EAEDEC',
    productImages: [],
};

ProductStage.propTypes = {
    /** alle valdiden CSS-Größen */
    size: PropTypes.string,

    /** alle validen CSS Farben */
    color: PropTypes.string,

    /** Hintergrundbild, überschreibt color prop */
    imageSrc: PropTypes.string,

    /** Array mit urls */
    productImages: PropTypes.array,
};

export default ProductStage;



// WEBPACK FOOTER //
// ./src/components/shared/ProductStage.js